import { GetStatusesEventFragment } from './getStatuses.generated-types'

interface Statuses {
  isAwaitingResponses: boolean
  isActiveWithResponses: boolean
  isRequestedToBook: boolean
  isBookingCancelled: boolean
  isBookingConfirmed: boolean
  isClosed: boolean
  noResponseWasChosen: boolean
}

export const getStatuses = ({ proposalCount, status }: GetStatusesEventFragment): Statuses => {
  return {
    isAwaitingResponses:
      status === 'Created' ||
      status === 'HostsInvited' ||
      status === 'ProposalsReceived' ||
      (proposalCount === 0 && status !== 'Cancelled'),
    isBookingCancelled: status === 'Cancelled' || status === 'Lost',
    isClosed: status === 'Closed',
    isRequestedToBook: false,
    isBookingConfirmed: status === 'RequestedToBook' || status === 'Completed',
    isActiveWithResponses:
      status === 'ProposalsSent' || (proposalCount > 0 && status === 'AwaitingDecision'),
    noResponseWasChosen: status === 'NoResponseChosen',
  }
}
